import useColors from "../../../../../../../api/hooks/useColors";

const useChartSeries = () => {
  const colors = useColors();

  return [
    {
      id: "os_within",
      isWithinSla: true,
      dataKey: "os_within",
      label: "Within SLA",
      stack: "os",
      stackLabel: "OS",
      color: colors.secondary_400,
      labelColor: colors.common_white,
    },
    {
      id: "os_not_within",
      isWithinSla: false,
      dataKey: "os_not_within",
      label: "Not Within SLA",
      stack: "os",
      stackLabel: "OS",
      color: colors.secondary_32percent,
      labelColor: colors.text_primary,
    },

    {
      id: "browser_within",
      isWithinSla: true,
      dataKey: "browser_within",
      label: "Within SLA",
      stack: "browser",
      stackLabel: "Browser",
      color: colors.primary_400,
      labelColor: colors.common_white,
    },
    {
      id: "browser_not_within",
      isWithinSla: false,
      dataKey: "browser_not_within",
      label: "Not Within SLA",
      stack: "browser",
      stackLabel: "Browser",
      color: colors.primary_32percent,
      labelColor: colors.text_primary,
    },

    {
      id: "thirdparty_within",
      isWithinSla: true,
      dataKey: "thirdparty_within",
      label: "Within SLA",
      stack: "thirdparty",
      stackLabel: "3rd Party",
      color: colors.info_400,
      labelColor: colors.common_white,
    },
    {
      id: "thirdparty_not_within",
      isWithinSla: false,
      dataKey: "thirdparty_not_within",
      label: "Not Within SLA",
      stack: "thirdparty",
      stackLabel: "3rd Party",
      color: colors.info_32percent,
      labelColor: colors.text_primary,
    },
  ];
};

export default useChartSeries;
